// src/components/Sidebar.jsx
import { NavLink } from 'react-router-dom';
import { HomeIcon,CurrencyDollarIcon,CloudIcon,SignalIcon,Square3Stack3DIcon ,KeyIcon,BellAlertIcon ,TicketIcon, UserIcon,ChatBubbleBottomCenterIcon, ClipboardDocumentListIcon  } from '@heroicons/react/24/outline';
import { logo } from '../assets/Images';
import { useState } from 'react';
import SupportTicketModal from './SupportTicketModal';
import { useReduxStore } from '../hooks/useReduxStore';
import { ImageUrl } from '../services/API';
import { glass } from '../styles/glass';
import useIsFreePlan from '../hooks/useIsFreePlan';
import { useUpgradeModal } from '../contexts/UpgradeModalContext';
import {
  LOCKED_NAV_FEATURE_NAMES,
  LOCKED_NAV_KEYS,
} from '../constants/lockedFeatures';

const menuItems = [
  { name: 'Home', path: '/Dashboard',
     icon: <HomeIcon className='h-6 w-6' />
     },
     { name: 'Layers', path: '/Dashboard/Layers', icon: <Square3Stack3DIcon  className='h-6 w-6' /> },
     { name: 'Forecast', path: '/Dashboard/Forecast', icon: <CloudIcon  className='h-6 w-6' /> },
     { name: 'Radar', path: '/Dashboard/Radar', icon: <SignalIcon  className='h-6 w-6' /> },
  { name: 'Profile', path: '/Dashboard/Profile', 
    icon: <UserIcon className='h-6 w-6' />
   },
  { name: 'Subscriptions', path: '/Dashboard/Subscription', 
    icon: <CurrencyDollarIcon  className='h-6 w-6' />
   },
  // { name: 'API Keys', path: '/Dashboard/APIKeys', icon: <KeyIcon  className='h-6 w-6' /> },
  { name: 'Bulletin Board', path: '/Dashboard/BulletinBoard', icon: <ClipboardDocumentListIcon className='h-6 w-6' /> },
  { name: 'Alerts', path: '/Dashboard/Alerts', icon: <BellAlertIcon  className='h-6 w-6' /> },
  { name: 'Chat', path: '/Dashboard/Chat', icon: <ChatBubbleBottomCenterIcon  className='h-6 w-6' /> },
  { name: 'Support', path: '/Dashboard/Support', icon: <TicketIcon  className='h-6 w-6' /> },
];

export default function Sidebar({ collapsed, mobileOpen = false, onCloseMobile }) {
  const {getState}=useReduxStore()
  const { settings } = getState("AUTH") || {};
  const isFreePlan = useIsFreePlan();
  const { handleLockedClick } = useUpgradeModal();
  const [showSupportModal, setShowSupportModal] = useState(false);

  const handleSupportClick = (e) => {
    e.preventDefault();
    setShowSupportModal(true);
  };

  const isMobileOverlay = !!mobileOpen;

  return (
    <>
      {/* Mobile overlay backdrop */}
      {isMobileOverlay && (
        <div
          className="fixed inset-0 bg-black/40 z-40 md:hidden"
          onClick={onCloseMobile}
        />
      )}

      <div
        className={`$${''}
          ${isMobileOverlay ? 'fixed left-0 top-0 h-screen z-[9999] md:relative md:z-auto' : 'md:relative'}
          ${mobileOpen ? 'block' : 'hidden'} md:block
          h-[100vh] ${glass} px-3 text-white transition-all duration-300 ${collapsed ? 'w-24' : 'w-[16rem]'} flex flex-col
        `.replace('$','')}
      >
        <div className="border-b border-borderGray p-4 pb-5 pt-6 text-center font-bold text-xl">
         {/* <Link to={"/"}> */}
          <img src={settings?.brandLogo?`${ImageUrl}${settings?.brandLogo}`:logo} className={`${collapsed?"h-8":"h-20"} ${collapsed?"w-8":"w-20"} mx-auto contain object-contain`}/>
          {/* </Link> */}
        </div>
        <nav className="mt-4 flex-1 h-[90%] overflow-y-auto pb-12 flex flex-col gap-2 px-2 thin-scrollbar">
          {menuItems.map((item) => {
            const isLockedItem =
              isFreePlan && LOCKED_NAV_KEYS.has(item.name);
            const baseClasses =
              'flex items-center gap-3 px-4 py-4 rounded-full text-sm font-medium w-full text-left';
            const hoverClass = isLockedItem
              ? 'hover:bg-white/5'
              : 'hover:bg-primaryBlue';
            return (
            item.name === 'Support' ? (
              <button
                key={item.name}
                onClick={handleSupportClick}
                className="flex items-center gap-3 px-4 py-4 hover:bg-primaryBlue rounded-full text-sm font-medium text-gray-300 w-full text-left"
              >
                <span className={`${collapsed?"text-sm":"text-lg"}`}>{item.icon}</span>
                {!collapsed && <span>{item.name}</span>}
              </button>
            ) : isLockedItem ? (
              <button
                key={item.name}
                type="button"
                onClick={() => {
                  handleLockedClick(LOCKED_NAV_FEATURE_NAMES[item.name]);
                  if (onCloseMobile) onCloseMobile();
                }}
                className={`${baseClasses} ${hoverClass} text-gray-300 opacity-80`}
              >
                <span className={`${collapsed ? "text-sm" : "text-lg"}`}>
                  {item.icon}
                </span>
                {!collapsed && <span>{item.name}</span>}
                <span className="ml-auto text-gray-400" title="Premium feature">
                  🔒
                </span>
              </button>
            ) : (
              <NavLink
                key={item.name}
                to={item.path}
                end
                onClick={() => {
                  if (onCloseMobile) onCloseMobile();
                }}
                className={({ isActive }) =>
                  `${baseClasses} ${hoverClass} ${
                    isActive ? "bg-primaryBlue" : "text-gray-300"
                  }`
                }
              >
                <span className={`${collapsed ? "text-sm" : "text-lg"}`}>
                  {item.icon}
                </span>
                {!collapsed && <span>{item.name}</span>}
              </NavLink>
            )
          );
          })}
        </nav>
      </div>

      {/* Support Ticket Modal */}
      <SupportTicketModal
        isOpen={showSupportModal}
        onClose={() => setShowSupportModal(false)}
      />
    </>
  );
}
